"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypeIsArrayTuple = exports.createParamDecorator = exports.createMixedDecorator = exports.createPropertyDecorator = exports.createClassDecorator = exports.createMethodDecorator = exports.emptyDecorator = exports.emptyFn = void 0;
function emptyFn(..._) {}
exports.emptyFn = emptyFn;
;
function emptyDecorator(..._) {
  return emptyFn;
}
exports.emptyDecorator = emptyDecorator;
exports.createMethodDecorator = emptyDecorator;
exports.createClassDecorator = emptyDecorator;
exports.createPropertyDecorator = emptyDecorator;
exports.createMixedDecorator = emptyDecorator;
exports.createParamDecorator = emptyDecorator;
exports.getTypeIsArrayTuple = emptyDecorator;
;
